export default "__VITE_ASSET__JOUbxzJL__"